import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-css-card',
    templateUrl: './css-card.component.html',
    styleUrls: ['./css-card.component.scss'],
    imports: [CommonModule]
})
export class CssCardComponent implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }

}
